module.exports = __webpack_public_path__ + "static/media/Ulang Alik (Blue).6db66ffc.png";